import { useEffect, useState } from "react";
// REDUX
import { useGetMessagesTypeQuery } from "../../redux/messageType/messagesTypeAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACES
import { MessageTypeInterface } from "../../interfaces/MessageType.interface";

export default function useGetAllMessagesTypes({ page = 1, limit = 999999 }: { page?: number; limit?: number } = {}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [messagesTypes, setMessagesTypes] = useState<MessageTypeInterface[]>([]);
	const [token, setToken] = useState<string | null>(null);
	const [errorObject, setErrorObject] = useState<any>({});
	const [errorMessage, setErrorMessage] = useState<string>("Error");

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const { data, isLoading, isError, isFetching, error } = useGetMessagesTypeQuery(
		{ token, page, limit },
		{ skip: !token, refetchOnMountOrArgChange: false } // if token exists, launch
	);

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		GETJwtToken().then(setToken);
	}, []);

	useEffect(() => {
		if (data && data.data) {
			setMessagesTypes(data.data);
		}
	}, [data]);

	useEffect(() => {
		if (error) {
			setErrorObject(error);
		}
	}, [error]);

	useEffect(() => {
		if (errorObject && errorObject.data && errorObject.data.message) {
			setErrorMessage(errorObject.data.message);
		}
	}, [errorObject]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return {
		messagesTypes,
		isLoadingGetAllMessagesTypes: isLoading || isFetching,
		errorMessageGetAllMessagesTypes: errorMessage,
		isErrorGetAllMessagesTypes: isError,
		totalRowsGetAllMessagesTypes: data?.total ?? 0,
	};
}
